<template>
  <div>
   <modal :show.sync="modal" class="col-12" id="commercial">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Atualização de preços no Siagri</h5>
      </template>
      <form role="form" @submit.prevent="sendConditionsForm()">
        <div class="row justify-content-md-center">
          <div class="col-md-12 form-group">
            <label class="form-control-label">Fornecedores <span style="color:red;">*</span></label><br>
            <el-select
              v-model="form.commercialBrands"
              label="desc_cta"
              filterable
              multiple
              remote
              collapse-tags
            >
              <el-option
                v-for="brand in brands"
                :key="brand.id"
                :label="brand.name || 'Nome não especificado'"
                :value="brand.id"
                :block-keys="['Tab', 'Enter']"
                @close="onTouch('type')"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12" style="padding-top: 1.5rem;">
            <label class="form-control-label">Usuários Externos</label>
            <tags-input
              v-model="form.externalEmails"
              label="Campo para inserir e-mail de usuários externos"
              placeholder="Insira um email"
            />
          </div>
          <div v-if="emailvalidationData" class="invalid-feedback" style="display: block;">
            {{ "Email inválido"}}
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button type="secondary" class="mr-2" @click="clear">Fechar</base-button>
        <base-button type="success" v-loading="isLoadingSave" @click="sendConditionsForm(form)">Enviar</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import TagsInput from "@/components/Inputs/TagsInput";

export default {
  name: "send-conditions-form",
  props: {
    modalUpdatePrice: {
      type: Boolean,
    },
    commercial: {
      type: Object,
      required: true
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    TagsInput
  },
  data() {
    return {
      brands: [],
      form: {
        commercialBrands: [],
        externalEmails: []
      },
      isLoadingSave: false
    };
  },
  mounted(){
    this.getCommercialBrands()
    .then(() => {
      this.initializeCommercialBrands();
    });
  },
  methods: {
    async getCommercialBrands() {

      const q = { commercial_id: this.commercial.id}
      try {
        const response = await this.$http.secured.get("/api/v2/commercial_brands",{
          params: {
            q: q,
            page: 1,
            per_page: 1000
          }
        })
        this.brands = response.data.data
        console.log(response.data)
      } catch (error) {
      console.log(error)
      }
    },
    initializeCommercialBrands() {
      this.form.commercialBrands = this.brands.map(brand => brand.id);
    },
    validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return (!email || re.test(email));
    },
    clear() {
      this.modal = false,
      this.form = {
        commercialBrands: [],
        externalEmails: []
      }
    },
    sendConditionsForm(form) {
      if (this.emailvalidationData || !form.externalEmails.length) return;
      if (!form.commercialBrands) return this.$toasted.global.defaultWarnig({ msg: 'Selecione um ou mais fornecedores para continuar' });

      this.isLoadingSave = true

      this.$http.secured.post("/api/v1/update_commercial_product_erp", {
        external_emails: form.externalEmails,
        commercial_brand_ids: form.commercialBrands
      })
      .then(() => {
        this.$toasted.global.defaultSuccess();
        this.isLoadingSave = false
        this.clear()
      })
      .catch(error => {
        this.$toasted.global.defaultError({ msg: 'Erro ao enviar condições comerciais' });
        console.error('Erro-SendConditionsForm', error)
        this.isLoadingSave = false
      })
    }
  },
  computed: {
    emailvalidationData() {
      return this.form.externalEmails.some((email) => { return this.validateEmail(email) == false })
    },
    modal: {
      get() {
        return this.modalUpdatePrice
      },
      set(val) {
        this.$emit('modalupdate-price:update', val)
      }
    }
  }
}
</script>